
import {
  defineStore
} from 'pinia'

export const useSlideoutSearchStore = defineStore('SlideoutSearchStore', {
  state: () => {
    return {
      slideoutSearchOpen: false
    }
  },

  actions: {
    openSlideoutSearch () {
      this.slideoutSearchOpen = true
      document.body.classList.add('overflow-hidden')
    },
    closeSlideoutSearch () {
      this.slideoutSearchOpen = false
      document.body.classList.remove('overflow-hidden')
    }
  },
})
